import type { TechTrackingInstance } from '@thehotelsnetwork/vue-tech-tracking';

import { settings } from './config';

import bdLogger from '@/utils/bdLogger';
import useDebugState from '@/state/useDebugState';

let instance: TechTrackingInstance;

const { isDebugActive } = useDebugState();

export const getTechTracking = async () => {
  if (isDebugActive.value) {
    bdLogger.warn('DataDog not initialized (debug environment)');
    return null;
  }
  if (!instance) {
    const { createTechTracking } = await import('@thehotelsnetwork/vue-tech-tracking');
    instance = createTechTracking(settings);
  }
  return instance;
};

export const techTrackingCatch = async ({
  err,
  context = {},
}: {
  err: string,
  context: object,
}) => {
  bdLogger.warn(err);

  const instance = await getTechTracking();
  if (!instance) {
    return;
  }
  instance.addAction(err, {
    ...context,
  });
};

export const techTrackingAction = async (name: string, context: object) => {
  const instance = await getTechTracking();
  if (!instance) {
    return;
  }
  instance.addAction(name, context);
};
